import React from 'react';
import './Layout.scss';
import HrbTranslate from '../language/HrbTranslate';

const Footer = () => {

    let currentYearParam = {
        CurrentYear: (new Date()).getFullYear()
    }

    return (
        <footer id='footer' className="columns">
            <div className='columns'>
                <div className='column is-half'>
                    <HrbTranslate text='Footer.Copyright' params={currentYearParam} className='is-pulled-left' />
                </div>
                <div className='column is-half'>
                    <HrbTranslate text='Footer.ActivityMonitored' className='is-pulled-right' />
                </div>
            </div>
            <div className='columns'>
                <div className='column is-half'>
                    <HrbTranslate text='Footer.Version' className='version is-pulled-left' />
                </div>
                <div className='column is-half' />
            </div>
        </footer>
    );
}

export default Footer
